function busyConfig(angularBusyDefaults) {
  angularBusyDefaults.delay = 50;
  angularBusyDefaults.minDuration = 300;
  angularBusyDefaults.wrapperClass = 'busy-animation-wrapper';
}

busyConfig.$inject = ['angularBusyDefaults'];

module.exports = busyConfig;



// WEBPACK FOOTER //
// ./src/azurebackup/angularBusy.config.js